import { render } from "./AddPhones.vue?vue&type=template&id=1a82e14a&scoped=true"
import script from "./AddPhones.vue?vue&type=script&lang=js"
export * from "./AddPhones.vue?vue&type=script&lang=js"

import "./AddPhones.vue?vue&type=style&index=0&id=1a82e14a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a82e14a"]])

export default __exports__